import React from 'react'

import Checkbox from '../Fields/Checkbox'

import content from '../../assets/content/Vestibuloplasty.json'

const ModuleThirtyFive = (props) => {
	return (
		<ol>
			{content.map((item, index) => {
				let itemNumber = index + 1
				return (
					<li key={index}>
						<Checkbox
							controlFunc={props.addToForm}
							name={`cBox${itemNumber}`}
							value={props.consentForm[`cBox${itemNumber}`]}
						/>{item}
					</li>
				)
			})}
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox5"}
					value={props.consentForm.cBox5}
				/>
				<u>ANESTHETIC RISKS include: discomfort, swelling, bruising, infection, and allergic reactions.</u> There may be inflammation at the site of an intravenous injection (phlebitis) that may cause prolonged discomfort and/or disability, and may require special care. Nausea and vomiting, although uncommon, may be unfortunate side effects of IV anesthesia. Intravenous anesthesia is a serious medical procedure and, although considered safe, carries with it the rare risks of heart irregularities, heart attack, stroke, brain damage or death.
			</li>
			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox6"}
					value={props.consentForm.cBox6}
				/>
				<strong><u>YOUR OBLIGATIONS IF IV ANESTHESIA IS USED</u></strong>
				<ol type="A">
					<li>Because anesthetic medications cause prolonged drowsiness, you MUST be accompanied by a responsible adult to drive you home and stay with you until you are recovered sufficiently to care for yourself. This may be up to 24 hours.</li>
					<li>During recovery time (24 hours) you should not drive, operate complicated machinery or devices, or make important decisions such as signing documents, etc.</li>
					<li><u>You must have a completely empty stomach. IT IS VITAL THAT YOU HAVE NOTHING TO EAT OR DRINK FOR <strong>EIGHT (8) HOURS </strong>PRIOR TO YOUR ANESTHETIC. <strong>TO DO OTHERWISE MAY BE LIFE-THREATENING!</strong></u></li>
					<li><strong>However,</strong> it is important that you take any regular medictions (high blood pressure, antibiotics, etc.) or medications provided by this office,<strong> using only a small sip of water.</strong></li>
				</ol>
			</li>

			<li>
				<Checkbox
					controlFunc={props.addToForm}
					name={"cBox7"}
					value={props.consentForm.cBox7}
				/>I understand that no guarantee can be promised, and I give my free voluntary consent for treatment. I realize that my doctor may discover conditions requiring different surgery from that which was planned, and I give my permission for those additional procedures that are advisable in the exercise of professional judgment.
			</li>
		</ol>
	)
}

export default ModuleThirtyFive


// WEBPACK FOOTER //
// ./src/components/Modules/35.js